"use strict";

import { formatPhoneNumberAU } from './formatPhoneNumberAU';
import { formatPhoneNumberNZ } from './formatPhoneNumberNZ';
export const formatPhoneNumber = (phoneNumber, tenant, addCountryCode = true) => {
  if (!phoneNumber) return '';
  switch (tenant) {
    case 'au':
      return formatPhoneNumberAU(phoneNumber, addCountryCode);
    case 'nz':
      return formatPhoneNumberNZ(phoneNumber, addCountryCode);
    default:
      return formatPhoneNumberAU(phoneNumber, addCountryCode);
  }
};